import PaymentMappersFactory from '../../payment/Mappers/factory.js'
import ProductsMappersFactory from '../../products/Mappers/factory.js'
import CheckoutEntitiesFactory from '../Entities/factory.js'
import CheckoutValueObjectsFactory from '../ValueObjects/factory.js'
import OrderRawDataToOrderEntityMapper from './OrderRawDataToOrderEntityMapper.js'
import PaymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper from './PaymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper.js'
import PurchaseCheckoutRawDataToPurchaseCheckoutEntityMapper from './PurchaseCheckoutRawDataToPurchaseCheckoutEntityMapper.js'

export default class CheckoutMappersFactory {
  static paymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper = () =>
    new PaymentMethodsCheckoutRawDataToPaymentMethodsCheckoutVOMapper({
      valueObject: CheckoutValueObjectsFactory.paymentMethodsValueObject
    })

  static orderRawDataToOrderEntityMapper = () =>
    new OrderRawDataToOrderEntityMapper({
      entity: CheckoutEntitiesFactory.orderEntity,
      productsToVisibilityProductsListVOMapper:
        ProductsMappersFactory.productsRawDataToVisibilityProductsListVOMapper(),
      priceRawDataToPriceVOMapper: PaymentMappersFactory.priceRawDataToPriceVOMapper(),
      taxRawDataToTaxVOMapper: PaymentMappersFactory.taxRawDataToTaxVOMapper()
    })

  static purchaseCheckoutRawDataToPurchaseCheckoutEntityMapper = () =>
    new PurchaseCheckoutRawDataToPurchaseCheckoutEntityMapper({
      entity: CheckoutEntitiesFactory.purchaseEntity
    })
}
